import { Card, CardContent, Paper, Typography } from '@mui/material';
import { MediaPlaylist } from '@signanthealth/modular-ui';
import React from 'react';

import type { MediaFile, MediaProps } from '../../../types/common.types.ts';

export const MediaContent: React.FC<{
  mediaFiles: Record<string, MediaProps[]>;
  textFiles: MediaFile[];
}> = ({ mediaFiles, textFiles }) => {
  const hasMediaFile = mediaFiles && Object.values(mediaFiles).some((file) => file.length > 0);
  const renderMedia = () => {
    return (
      <>
        {hasMediaFile && (
          <MediaPlaylist
            videoList={mediaFiles.video}
            audioList={mediaFiles.audio}
            documentList={mediaFiles.pdf}
            imageList={mediaFiles.image}
            allowAllMediaDownload={true}
          />
        )}
        {textFiles.map((file) => (
          <Paper
            key={file.title}
            elevation={0}
            sx={{
              p: 3,
              bgcolor: 'grey.50',
              minHeight: 200,
              maxHeight: 480,
              overflow: 'auto',
            }}
          >
            <CardContent>
              <Typography variant="h6" component="div" data-testid={`${file.title}-media-title`}>
                {file.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                data-testid={`${file.title}-media-description`}
              >
                {file.description}
              </Typography>

              <Typography variant="body1" component="div" sx={{ whiteSpace: 'pre-wrap' }}>
                {file.content}
              </Typography>
            </CardContent>
          </Paper>
        ))}
      </>
    );
  };
  return (
    <Card sx={{ width: '100%', mb: 2 }} data-testid="media-content">
      {renderMedia()}
    </Card>
  );
};
